import { TableProps } from '.';

// This object should contain a mock value for each required prop of this component
export const requiredProps: TableProps = {
  columns: [{ title: 'A', render: row => row.a }],
};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as TableProps,
  },
];

export const testkitTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
      data: [{ a: 'value 1', b: 'value 2' }],
    } as TableProps,
  },
];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
